import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ScorecardFragment = { id: string, title: string, skill?: { name: string, id: string } | null, questions?: Array<{ id: string, text: string, order: number, maxScore: number }> | null };


export type ScorecardFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ScorecardFragmentDoc = /*#__PURE__*/ gql`
    fragment Scorecard on ScorecardType {
  id
  title
  skill {
    name
    id
  }
  questions {
    id
    text
    order
    maxScore
  }
}
    `;